import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Cohort } from '~/shared/constants/commonConstants'
import { getVariantAction } from '~/shared/store/common/actions'

export const useSetVariant = (): void => {
  const dispatch = useDispatch()

  const URLParams = new URLSearchParams(document.location.search)
  const cohortFromUrl = URLParams.get('cohort')

  useEffect(() => {
    dispatch(getVariantAction({ cohort: cohortFromUrl || Cohort.BIOLOGY }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
